import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { trashIcon } from "@tql/ui-components-react/kendo/svg-icons";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";

import type { Rule } from "../../../modal/utils/types.ts";

type RuleActionsCellProps = GridCustomCellProps & {
	handleRemoveRow: (id: number) => void;
	cellTestId?: string;
};

export const RuleActionsCell = ({
	handleRemoveRow,
	...props
}: RuleActionsCellProps) => (
	<GridTd data-testid={props.cellTestId} tdProps={props.tdProps}>
		<button
			aria-label={"Remove Rule"}
			onClick={() => handleRemoveRow((props.dataItem as Rule).id)}
			style={{
				background: "none",
				border: "none",
				cursor: "pointer",
				padding: 0,
			}}
			type={"button"}
		>
			<SvgIcon icon={trashIcon} />
		</button>
	</GridTd>
);
